var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-approval-4159935 1",
    clipPath: "url(#clip0_24_7189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3199 24.7603C17.3199 26.7042 15.744 28.2804 13.7998 28.2804C11.8559 28.2804 10.28 26.7042 10.28 24.7603C10.28 22.8161 11.8559 21.2402 13.7998 21.2402C15.744 21.2402 17.3199 22.8161 17.3199 24.7603Z",
    fill: "#268A66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9201 29.3203C16.0401 29.9202 14.96 30.2804 13.8001 30.2804C12.6401 30.2804 11.5601 29.9204 10.6801 29.3203C9.08021 29.8803 7.96021 31.3602 7.96021 33.1202V35.1202C7.96021 35.5204 8.28024 35.8401 8.68006 35.8401H17.2401C17.36 34.2 18.1201 32.7201 19.3601 31.6802C18.9602 30.6002 18.0401 29.7202 16.9201 29.3203Z",
    fill: "#268A66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.7198 24.7603C39.7198 26.7042 38.1439 28.2804 36.2 28.2804C34.2558 28.2804 32.6799 26.7042 32.6799 24.7603C32.6799 22.8161 34.2558 21.2402 36.2 21.2402C38.1439 21.2402 39.7198 22.8161 39.7198 24.7603Z",
    fill: "#268A66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.3198 29.3203C38.4398 29.9202 37.3597 30.2804 36.1998 30.2804C35.0399 30.2804 33.9599 29.9204 33.0798 29.3203C31.9199 29.7204 31.0399 30.6005 30.5999 31.7205C31.8398 32.7604 32.5999 34.2405 32.7199 35.8803H41.2799C41.68 35.8803 41.9997 35.5603 41.9997 35.1605V33.1605C42.0396 31.3602 40.8798 29.8803 39.3198 29.3203Z",
    fill: "#268A66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.5199 27.9202C28.5199 29.8644 26.9437 31.4402 24.9998 31.4402C23.0559 31.4402 21.4797 29.8644 21.4797 27.9202C21.4797 25.9762 23.0559 24.4004 24.9998 24.4004C26.9437 24.4004 28.5199 25.9762 28.5199 27.9202Z",
    fill: "#268A66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.1198 32.4395C27.2398 33.0393 26.1597 33.3995 24.9998 33.3995C23.8398 33.3995 22.7598 33.0396 21.8798 32.4395C20.2799 32.9994 19.1599 34.4794 19.1599 36.2394V38.2394C19.1599 38.6395 19.4799 38.9592 19.8798 38.9592H30.0798C30.4799 38.9592 30.7996 38.6392 30.7996 38.2394V36.2394C30.8398 34.4793 29.6796 32.9995 28.1196 32.4395H28.1198Z",
    fill: "#268A66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.1598 19.5999C17.3599 19.7597 17.5998 19.7999 17.7999 19.7999C18.1199 19.7999 18.4799 19.64 18.6799 19.3599L21.1598 16.0399C22 16.4799 22.9199 16.8 23.8797 16.9199V20.88C23.8797 21.4799 24.3596 22 24.9997 22C25.6397 22 26.1197 21.5201 26.1197 20.88V16.9199C27.0797 16.7999 27.9997 16.4799 28.8395 16.0399L31.3195 19.3599C31.5195 19.64 31.8794 19.7999 32.1995 19.7999C32.4394 19.7999 32.6395 19.7198 32.8395 19.5999C33.3194 19.2399 33.4394 18.5599 33.0795 18.0399L30.5998 14.7199C32.0798 13.2799 33 11.2399 33 9C33 4.56 29.4001 1 25 1C20.56 1 17 4.59986 17 9C17 11.2399 17.9199 13.2801 19.4001 14.7199L16.9202 18.0798C16.56 18.56 16.6799 19.2399 17.1598 19.5999ZM21.0398 8.35986C21.4798 7.91984 22.1997 7.91984 22.6397 8.35986L23.9198 9.64L27.3598 6.2C27.7998 5.75999 28.5197 5.75999 28.9597 6.2C29.3997 6.64001 29.3997 7.35986 28.9597 7.79986L24.7198 12.0398C24.5197 12.2398 24.1997 12.3598 23.9198 12.3598C23.6397 12.3598 23.3199 12.2398 23.1199 12.0398L21.0398 9.95971C20.5998 9.51999 20.5998 8.79986 21.0398 8.35986Z",
    fill: "#268A66"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_7189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 42,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.15b978de86c900ef84361a1719b97611.svg";
export { ForwardRef as ReactComponent };